import { render } from "./HotelDetail.vue?vue&type=template&id=ca77e34c&scoped=true"
import script from "./HotelDetail.vue?vue&type=script&lang=js"
export * from "./HotelDetail.vue?vue&type=script&lang=js"

import "./HotelDetail.vue?vue&type=style&index=0&id=ca77e34c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca77e34c"]])

export default __exports__